// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sA","control":"sB","leftControl":"sC sB","rightControl":"sD sB","hide":"sE tw"};